import {Directive, Input, ElementRef, AfterViewInit, AfterContentInit} from 'angular2/core';
import {NgControlName} from 'angular2/common';

/*
 Select2 is a library to build custom <select> element that allow us to perform:
 * autocomplete
 * fancy multiple select
 * search
 * and more
 See more https://select2.github.io/
 */

@Directive({
    selector: "[datepicker]"
})

export class Datepicker implements AfterViewInit, AfterContentInit {
    @Input('datepicker') control:NgControlName;
    private _element:JQuery;

    constructor(private _elementRef:ElementRef) {
        this._element = jQuery(_elementRef.nativeElement);
    }

    ngAfterViewInit() {
        this._element.attr("type", "text");
        this._element.attr("placeholder", "ex: 2016-02-28");
        this._element.datepicker({
            language: "fr", //TODO get local
            todayHighlight: true,
            format: "yyyy-mm-dd",
            autoclose: true,
            weekStart: 1
        });
    }

    fnChange($event) {
        if (this.control.viewModel !== this._element.val()) {
            this.control.viewToModelUpdate(this._element.val());
        }
    }

    ngAfterContentInit() {
        this._element.on("change", this.fnChange.bind(this));
    }
}
